import { inject, Injectable } from '@angular/core';
import { ApiAssetsAdapterService } from '@fullyops/data/assets/api-adapter';
import { ListedAsset } from '@fullyops/data/assets/asset';
import { createStore } from '@ngneat/elf';
import {
  deleteAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';

@Injectable({ providedIn: 'root' })
export class ListedAssetsService {
  private api = inject(ApiAssetsAdapterService);

  private store = createStore(
    { name: 'listed-assets' },
    withEntities<ListedAsset>({ idKey: 'id' }),
  );

  readonly assets$ = this.store.pipe(selectAllEntities());

  refresh(): void {
    this.api.getAll().subscribe((as) => this.store.update(setEntities(as)));
  }

  clear(): void {
    this.store.update(deleteAllEntities());
  }
}
